import React from 'react';
import PropTypes from 'prop-types';

const IconSortUp = ({ size, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fill}
        viewBox="0 -200 1792 1792"
    >
        <path d="M1408 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z" />
    </svg>
);

IconSortUp.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconSortUp.defaultProps = {
    size: 17,
    fill: 'white',
};

IconSortUp.displayName = 'SortUp';

export default IconSortUp;
